import BaseProxy from './Base';

class JerseysProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('jerseys', parameters, 'api/v1');
  }

  getJerseys({ job_id, track_id, ...parameters }) {
    this.setParameters(parameters);
    this.endpoint = `${this.endpoint}/${job_id}/${track_id}`;
    return this.load();
  }

  getJerseysBySeconds({ job_id, track_id, ...parameters }) {
    this.setParameters(parameters);
    this.endpoint = `api/v1/jerseys_step/${job_id}/${track_id}`;
    return this.load();
  }

  getJerseysFastOverview(job_id, track_id) {
    this.endpoint = `api/v1/jerseys_fast_overview/${job_id}/${track_id}`;
    return this.load();
  }

  getJerseysRandom({ job_id, track_id, ...parameters }) {
    this.setParameters(parameters);
    this.endpoint = `api/v1/jerseys_overview/${job_id}/${track_id}`;
    return this.load();
  }

  getNumbers({ job_id, track_id }) {
    this.endpoint = `api/v1/jerseys_stats/${job_id}/${track_id}`;
    return this.load();
  }
  
  getPotentialSplitPoints({ job_id, track_id, ...parameters }) {
    this.setParameters(parameters);
    this.endpoint = `api/v1/jobs/${job_id}/track_potential_split_points/${track_id}`;
    return this.load();
  }
}

export default JerseysProxy;
